import { useEffect, useState } from "react";

/**
 * Détecte si l'utilisateur est sur un appareil tactile (mobile/tablette).
 * Retourne true si c'est le cas, false sinon.
 */
export function useTouchDevice(): boolean {
  const [touchDevice, setTouchDevice] = useState(false);

  useEffect(() => {
    const isTouch =
      typeof window !== "undefined" &&
      ("ontouchstart" in window || navigator.maxTouchPoints > 0);
    setTouchDevice(isTouch);
  }, []);

  return touchDevice;
}
